import React from 'react';
import { ScommesseLeafItemProps } from './types';
import { useInfoAggiuntivaData } from 'features/sport/hooks';
import { useTranslation } from 'hooks/useLingUI';

export const InfoAggiuntivaCell = ({ itemKey }: ScommesseLeafItemProps) => {
  const { t } = useTranslation();

  const infoAggData = useInfoAggiuntivaData(itemKey);
  const { valore, valoreTrKey } = infoAggData ?? {};

  return (
    <React.Fragment key={`InfoAggiuntivaCell-${valoreTrKey}-${valore}`}>{t(valoreTrKey, valore ?? '-')}</React.Fragment>
  );
};
